import { render, staticRenderFns } from "./Senasoft.vue?vue&type=template&id=ca6ecfde"
import script from "./Senasoft.vue?vue&type=script&lang=js"
export * from "./Senasoft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports